import { FINANCE_CLIENT_DETAILS_LIST } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

export const financeClientDetailsList = () => ({
  // Add a cache-buster because the backend GET is redis-cached and write endpoints
  // don't currently invalidate that cache.
  url: `${FINANCE_CLIENT_DETAILS_LIST}?cb=${Date.now()}`,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
});

export const createFinanceClient = (clientName, clientStatus) => ({
  url: FINANCE_CLIENT_DETAILS_LIST,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: {
    clientName,
    clientStatus: Number(clientStatus),
  },
  service: serviceName.PROJECT_MS,
});

export const updateFinanceClient = (clientId, clientName, clientStatus) => ({
  url: `${FINANCE_CLIENT_DETAILS_LIST}/${clientId}`,
  method: 'put',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  payload: {
    clientName,
    clientStatus: Number(clientStatus),
  },
  service: serviceName.PROJECT_MS,
});
